import Button from "../../../../utilities/Button";
import {useStores} from "../../../../../stores/useStores";

export function LogoutButton(props) {
    const {userStore} = useStores();

    return <Button onClick={async () => {
        await userStore.logout();
    }} {...props}>{props.children}</Button>
}
